<template>
  <StepperRoot class="StepperList" :modelValue="modelValue" @update:modelValue="(value: number) => $emit('update:modelValue', value)">
    <slot name="items">
      <WStepperItem
        v-for="(item, index) in computedItemsList"
        :key="index"
        :value="index + 1"
        :icon="item?.icon"
        :hide-separator="index === computedItemsList.length - 1"
      />
    </slot>
  </StepperRoot>
</template>

<script setup lang="ts">
  import { StepperRoot } from 'radix-vue';
  import { computed } from 'vue';
  import WStepperItem from './WStepperItem.vue';

  const $emit = defineEmits(['update:modelValue']);

  export interface Props {
    items?: { icon: string }[];
    totalItems?: number;
    modelValue?: number;
  }

  const props = defineProps<Props>();

  const computedItemsList = computed(function () {
    return props?.items || (Array.from({ length: props.totalItems || 0 }).fill({ icon: '' }) as { icon: string }[]);
  });
</script>

<style scoped lang="scss">
  @import '@/assets/styles/variables';

  .StepperList {
    display: flex;
    gap: 1rem;
    justify-content: center;

    @media screen and (min-width: 768px) {
      min-width: 400px;
    }
  }
</style>
